import styled from 'styled-components';
import { colorUsage, getSpacing, headerHeight, pageWidth, zIndex } from 'stylesheet';
export var FormHeader = styled.div.withConfig({
  displayName: "ContentFormstyle__FormHeader",
  componentId: "sc-31oil3-0"
})(["position:fixed;top:", ";left:50%;z-index:calc(", " - 1);display:flex;align-items:center;justify-content:center;width:", "px;padding:", " 0;background-color:", ";transform:translate(-50%,0);"], headerHeight, zIndex.header, pageWidth.small, getSpacing(3), colorUsage.headerBackground);